import React, { useState } from "react";
import { Button } from "react-bootstrap";
import excel from "../../../assets/images/xls.svg";
import ESTooltip from "../../../controls/ESTooltip";
import { expotExcel } from "../../../utils/ApiUrl";
import { axiosPost } from "../../../utils/AxiosHelper";
import { convertToUTC, createExcelFile } from "../../../utils/common";
import { showToast, ToastTypeCode } from "../../../utils/Constant";
import Loader from "../../loader/Loader";
import "../ExportExcel/ExportExcel.scss";

interface ExportExcelProps {
  searchText: string;
  model: any;
  componentName: any;
  fileName: any;
  surveyAssignmentId?: number;
  orgId?: number;
  isPending?: boolean | null;
  pagesize?: number;
  currentpage?: number;
  questionCategoryId?: number;
  effectiveStartDate?: Date | null;
  effectiveEndDate?: Date | null;
  routeFlag?: any;
  IsPoll?: boolean;
  assignedUserId?: number;
  responseGroupGuid?: string | null;
  containerClass?: string;
}

type ModelItem = {
  question: string;
  responseType: string;
  options: string[];
  responses: string[][];
};

type TransformedData = {
  SrNo: string;
  Question: string;
  ResponseType: string;
  [key: string]: string;
};

const ExportExcel: React.FC<ExportExcelProps> = ({
  searchText,
  model,
  componentName,
  fileName,
  surveyAssignmentId,
  orgId,
  isPending,
  pagesize,
  currentpage,
  effectiveStartDate,
  effectiveEndDate,
  questionCategoryId,
  routeFlag,
  IsPoll,
  assignedUserId,
  responseGroupGuid,
  containerClass
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // const transformData = (model: ModelItem[]): TransformedData[] => {
  //   const transformedData: TransformedData[] = [];
  //   let serialNumber = 1;

  //   model.forEach((item, index) => {
  //     const { question, options, responses, responseType } = item;
  //     let isFirstOption = true;

  //     options.forEach((option, optIndex) => {
  //       const responseRow: TransformedData = {
  //         SrNo: isFirstOption ? serialNumber.toString() : "",
  //         Question: isFirstOption ? question : "",
  //         ResponseType: isFirstOption ? responseType : "",
  //         ResponseOption: option,
  //       };

  //       responses.forEach((response, resIndex) => {
  //         responseRow[`User ${resIndex + 1}`] = response[optIndex] || "";
  //       });

  //       transformedData.push(responseRow);
  //       isFirstOption = false;
  //     });

  //     serialNumber++;
  //   });
  //   return transformedData;
  // };



  const handleExport = async () => {
    setLoading(true);
    setError(null);

    try {
      if (componentName === "ReportsQuestionBase") {
        // const transformedData = transformData(model);
        createExcelFile(model, fileName);
      } else if (
        componentName === "ReportsUserBase" ||
        componentName === "UserDataForParticularOption" ||
        componentName === "SentimentExportbase" ||
        componentName === "EmailLogDetailsData" ||
        componentName === "ResetDetailsData"
      ) {
        createExcelFile(model, fileName);
      } else {
        const payload: any = {
          SearchText: searchText,
          OrganizationId: orgId !== undefined ? orgId : model?.[0]?.OrganizationId,
          ComponentName: componentName,
        };

        if (surveyAssignmentId !== undefined) {
          payload.SurveyAssignmentId = surveyAssignmentId;
        }
        if (routeFlag !== undefined) {
          payload.RouteFlag = routeFlag;
        }
        if (isPending !== undefined) {
          payload.IsPending = isPending;
        }
        if (IsPoll !== undefined) {
          payload.IsPoll = IsPoll;
        }
        if (pagesize !== undefined) {
          payload.PageSize = pagesize;
        }

        if (assignedUserId !== undefined) {
          payload.AssignedUserId = assignedUserId;
        }
        if (responseGroupGuid !== undefined) {
          payload.ResponseGroupGuid = responseGroupGuid;
        }

        if (currentpage !== undefined) {
          payload.CurrentPageNo = currentpage;
        }

        if (
          componentName === "QuestionsLists" &&
          questionCategoryId !== undefined
        ) {
          payload.QuestionCategoryId = questionCategoryId;
        }

        if (
          componentName === "QuestionsList" &&
          questionCategoryId !== undefined
        ) {
          payload.QuestionCategoryId = questionCategoryId;
        }


        if (effectiveStartDate !== undefined && effectiveStartDate !== null) {
          // const utcStartDate = new Date(
          //   effectiveStartDate.getTime() -
          //     effectiveStartDate.getTimezoneOffset() * 60000
          // )
          //   .toISOString()
          //   .split("T")[0];
          const utcStartDates2 = convertToUTC(effectiveStartDate);
          payload.EffectiveStartDate = utcStartDates2;
        }
        if (effectiveEndDate !== undefined && effectiveEndDate !== null) {
          // const utcEndDate = new Date(
          //   effectiveEndDate.getTime() -
          //     effectiveEndDate.getTimezoneOffset() * 60000
          // )
          //   .toISOString()
          //   .split("T")[0];
          const utcEndDate2 = convertToUTC(effectiveEndDate);
          payload.EffectiveEndDate = utcEndDate2;
        }

        const blob: any = await axiosPost(expotExcel, payload);
        createExcelFile(blob.data.ExtraData, fileName);
      }
    } catch (error) {
      showToast("Failed to download Excel file", ToastTypeCode?.ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={containerClass || "export-excel-container"}>
      <ESTooltip text="Export Data to Excel" placement="top" >
        <button type="button" className={`btn-export-excel ${containerClass || ""}`} onClick={handleExport} disabled={loading} data-tour="download-data">
          {/* {loading ? "Exporting..." : "Export to Excel"} */}
          <img src={excel} alt="excel" />
        </button>
      </ESTooltip>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading ? <Loader /> : null}
    </div>
  );
};

export default ExportExcel;
